// What a generation costs. The authority is the price list super-admins set in Admin → AI Generation
// Pricing (backend/src/services/generationCostService.js), which GET /workspaces/:id returns as
// `creditCosts.generation` and useWorkspace() exposes — pass that in. This copy is only the
// fallback for a response that predates the field, and matches the backend's DEFAULT_COSTS.
//
// It used to be the ONLY copy the UI had, kept in sync by hand, and it drifted: from 14 Sep 2026
// this quoted 10 / 35 / 100 while the backend charged 1 / 5 / 25.
export const GENERATION_COSTS: Record<'text' | 'photo' | 'video', number> = {
  text: 10,
  photo: 35,
  video: 100,
};

export type ContentType = 'text' | 'photo' | 'video';
export type GenerationCosts = Record<ContentType, number>;

export function calculateGenerationCost(contentTypes: string[], costs: GenerationCosts = GENERATION_COSTS): number {
  return (contentTypes || []).reduce(
    (sum, t) => sum + (costs[t as ContentType] || 0),
    0,
  );
}

export function costBreakdown(
  contentTypes: string[],
  costs: GenerationCosts = GENERATION_COSTS,
): { type: ContentType; cost: number }[] {
  return (['text', 'photo', 'video'] as ContentType[])
    .filter((t) => contentTypes?.includes(t))
    .map((t) => ({ type: t, cost: costs[t] }));
}

// Credit balances and message costs are fractional — a WhatsApp send costs 7.5 or 5.4
// credits and an SMS 0.32 (backend/src/config/messageCosts.js) — so never render one
// with bare String(n) or assume an integer.
export function formatCredits(value: number | null | undefined): string {
  if (value == null || Number.isNaN(Number(value))) return '0';
  return Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 });
}
